// https://webpack.js.org/guides/dependency-management/#requirecontext
const orgapiFiles = require.context('./orgapi', true, /\.js$/)

// you do not need `import app from './modules/app'`
// it will auto require all vuex module from modules file
const orgapi = orgapiFiles.keys().reduce((orgapi, apiPath) => {
    // set './app.js' => 'app'

    const apiName = apiPath.replace(/^\.\/(.*)\.\w+$/, '$1')

    const value = orgapiFiles(apiPath)

    orgapi[apiName] = value.default

    return orgapi
}, {})
export default orgapi